// utilisation de la fonction
/*var date = new Date();
var results = getDateDetails(date);
*/

// Fonctions

/**
 * Get Details of a Date Object
 *
 * @param Date date : Js Date Object
 * @return Object|bool
 */
export function getDateDetails(date)
{
	var isDateADateObject = date instanceof Date;
	if (!isDateADateObject) {
		return false;
	}

	// get day, month and year from date object
	var day = ("0" + date.getDate()).slice(-2);
	var month = date.getMonth();
	var year = date.getFullYear();

	// construct the object to return
	var obj = new Object();
	obj.d1 = getDayDigit(day, 0);
	obj.d2 = getDayDigit(day, 1);
	obj.month3letters = getMonth3letters(parseInt(month));
	obj.y1 = getYearDigit(year, 0);
	obj.y2 = getYearDigit(year, 1);
	obj.y3 = getYearDigit(year, 2);
	obj.y4 = getYearDigit(year, 3);

	return obj;
}

/**
 * Get Month with 3 letters
 *
 * @param int monthNumber : Month Number (from 0 to 11)
 * @return string|bool
 */
function getMonth3letters(monthNumber)
{
	if (monthNumber !== parseInt(monthNumber, 10) || monthNumber > 11) {
		return false;
	}

	var months = [
		'jan',
		'fév',
		'mar',
		'avr',
		'mai',
		'jun',
		'jul',
		'aou',
		'sep',
		'oct',
		'nov',
		'déc',
	];

	return months[monthNumber];
}

/**
 * Get year Digit string, given a year string (4 characters) and a position (0 to 3)
 * Ie : 1982
 * position 0 => 1
 * position 1 => 9
 * position 2 => 8
 * position 3 => 2
 *
 * @param string year : Year
 * @param int position : Position
 * @return string
 */
function getYearDigit(year, position)
{
	var yearDigits = ("" + year).split("");

	return yearDigits[position];
}

/**
 * Get day Digit string, given a day string (2 characters) and a position (0 to 3)
 * Ie : 01
 * position 0 => 0
 * position 1 => 1
 *
 * @param string day : Day
 * @param int position : Position
 * @return string
 */
function getDayDigit(day, position)
{
	var dayDigits = ("" + day).split("");

	return dayDigits[position];
}


// WEBPACK FOOTER //
// ./src/client/pages/simulator/components/dashboard/date_details.js